export { default } from './ArrowLink';



// WEBPACK FOOTER //
// ./src/components/atoms/ArrowLink/index.js